import MultiSelectPicker from './MultiSelectPicker'

export default MultiSelectPicker
